import React from "react";
import {
  Button,
  Dialog,
  DialogProps,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import styles from "./DetailFileInfoDialog.css";
import { ActionLink } from "../url/ActionLink";

export type DetailFileInfoDialogStateType = {
  title: string;
  sourceType: string;
  fileName: string;
  fileType: string;
  filePath: string;
  dirPath: string;
  url: string;
  contentText: string;
  thumbnail: string;
  createDate: string;
  updateDate: string;
};

interface Props {
  open: boolean;
  onClose: () => void;
  scroll: DialogProps["scroll"];
  detailFileInfoDialogState: DetailFileInfoDialogStateType;
  onOpenPreviewDialog: (event: React.MouseEvent<HTMLElement>) => void;

  // [HP稼働]: electronからの修正(不要処理削除)
  // onOpenPath: (event: React.MouseEvent<HTMLElement>) => void;
  // onShowItemInFolder: () => void;
  // onSTSearch: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

/** 詳細ファイル情報ダイアログ */
export function DetailFileInfoDialog(props: Props) {
  //------------------------------
  // openステート
  // [State]
  const { open } = props;
  // [Handler]
  const { onClose } = props;

  //------------------------------
  // ダイアログ設定
  // [State]
  const { scroll } = props;
  const { detailFileInfoDialogState } = props;
  // [Handler]
  const { onOpenPreviewDialog } = props;

  // [HP稼働]: electronからの修正(不要処理削除)
  // const { onOpenPath } = props;
  // const { onShowItemInFolder } = props;
  // const { onSTSearch } = props;

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    let cleanedUp = false;

    if (open && !cleanedUp) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [open]);

  //--------------------
  // コンポーネント
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        color="textPrimary"
        maxWidth="lg"
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {detailFileInfoDialogState.title}
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            ファイル名：&ensp;
            {detailFileInfoDialogState.fileName}
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            ファイルタイプ：&ensp;
            {detailFileInfoDialogState.fileType}
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            取得元：&ensp;
            {detailFileInfoDialogState.sourceType === "NAS"
              ? "ファイル"
              : "ウェブ"}
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {detailFileInfoDialogState.sourceType === "NAS" ? (
              <>
                格納フォルダ：&ensp;
                {detailFileInfoDialogState.dirPath}
              </>
            ) : (
              <>
                URL：&ensp;
                <ActionLink url={detailFileInfoDialogState.url} />
              </>
            )}
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            先頭文字列：&ensp;
            {detailFileInfoDialogState.contentText}
          </DialogContentText>
          <Divider />
          {/* [HP稼働]: electronからの修正(不要処理削除) */}
          {/* <img
            src={`data:image/jpeg;base64,${detailFileInfoDialogState.thumbnail}`}
            className={styles["img-thumb"]}
            alt={detailFileInfoDialogState.filePath}
          />
          <Divider /> */}
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            className={styles["create-date"]}
          >
            作成日：&ensp;
            {detailFileInfoDialogState.createDate}
          </DialogContentText>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            更新日：&ensp;
            {detailFileInfoDialogState.updateDate}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-between" }}>
          <div>
            <Button onClick={onOpenPreviewDialog} color="primary">
              プレビュー
            </Button>
            {/* [HP稼働]: electronからの修正(不要処理削除) */}
            {/* {detailFileInfoDialogState.sourceType === "NAS" ? (
              <>
                <Button onClick={onOpenPath} color="primary">
                  アプリで開く
                </Button>
                <Button onClick={onShowItemInFolder} color="primary">
                  ファイルの場所を開く
                </Button>
              </>
            ) : (
              <></>
            )}
            <Button onClick={onSTSearch} color="primary">
              類似検索
            </Button> */}
          </div>
          <div>
            <Button onClick={onClose} color="primary">
              閉じる
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
